import { useCallback, useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import styled from "styled-components";
import {
  Autocomplete,
  Button,
  Chip,
  Container,
  CssBaseline,
  FormHelperText,
  Grid,
  InputAdornment,
  MenuItem,
  Pagination,
  Snackbar,
  SnackbarContent,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { useDropzone } from "react-dropzone";
import { useAuth } from "../authContext";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DraftsIcon from '@mui/icons-material/Drafts';
import CloseIcon from '@mui/icons-material/Close';
import TrashIcon from "../assets/icon/TrashIcon";
import FilterIcon from "../assets/icon/FilterIcon";
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { NumericFormat } from "react-number-format";
import TagService from "../services/manager/tagService";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import LiqueModal from "../customer/components/liqueModal";
import StockSortableList from "./components/stockSortableList";
import ImageSortableList from "./components/imageSortableList";
import AdminNavigation from "./adminNavigation";
import InventoryService from "../services/manager/inventoryService";
import { btnStyleContrast, btnStyleContrastGray, btnStyleOutlined, lightergrayHex, roudedIconButtonStyle, headerStyleContrast, subHeaderStyleContrast, textSmallStyleContrast, textStyleContrast, textStyleLargeContrast } from "../helper/style";
import noImage from "../assets/no-image.png";
import { DatePicker, LocalizationProvider, DateTimePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import PartnerService from "../services/manager/partnerService";
import { base64ToFile, compressImageWebp } from "../helper/helperFunctions";
import UploadImageSortableList from "./components/uploadImageSortableLis";

const imageUrl = process.env.REACT_APP_IMAGE_URL;

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default function ReviewStok() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const [rows, setRows] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [msgSuccess, setmsgSuccess] = useState("");
  const [showError, setShowError] = useState(false);
  const [msgError, setMsgError] = useState();
  const [showMsgImage, setShowMsgImage] = useState(false);
  const [msgImageError, setMsgImageError] = useState();
  const [showMsgSizeChart, setShowMsgSizeChart] = useState(false);
  const [msgSizeChartError, setMsgSizeChartError] = useState();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const [name, setname] = useState("");
  const [tipeBarang, settipeBarang] = useState(null);
  const [typeData, setTypeData] = useState([]);
  const [partners, setPartners] = useState([]);
  const [employeeId, setemployeeId] = useState("");
  const [customWeight, setcustomWeight] = useState("");
  const [customDefaultPrice, setcustomDefaultPrice] = useState(0);
  const [finalPrice, setFinalPrice] = useState(0);
  const [description, setDescription] = useState("");
  const [discountType, setDiscountType] = useState("N");
  const discountTypeArr = [
    { value: "N", title: "None"}, 
    { value: "P", title: "Persen"}, 
    { value: "H", title: "Harga"}, 
  ];
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountStart, setDiscountStart] = useState(null);
  const [discountEnd, setDiscountEnd] = useState(null);
  const [files, setFiles] = useState([]);
  const [oldFiles, setOldFiles] = useState([]);
  const [sizeChart, setSizeChart] = useState([]);
  const [oldSizeChart, setOldSizeChart] = useState([]);
  const [inputTagMain, setInputTagMain] = useState([]);
  const [inputTagSecondary, setInputTagSecondary] = useState([]);
  const [inputBrand, setInputBrand] = useState(null);
  const [inputPartner, setInputPartner] = useState(null);
  const [itemType, setItemType] = useState("S");
  const itemTypeArr = [
    { value: "S", title: "Fullfillment" }, // standard
    { value: "A", title: "Non-Fullfillment" }, // affiliate
  ]
  const [shopeeLink, setShopeeLink] = useState("");
  const [tiktokLink, setTiktokLink] = useState(""); 
  const [itemState, setItemState] = useState("A");
  const itemStateArr = [
    {title: 'Active', value: 'A'},
    {title: 'Draft', value: 'D'},
  ];
  const [itemLabels, setItemLabels] = useState([]);
  const [itemLabeltext, setItemLabelText] = useState("");

  const [errors, setErrors] = useState({});
  const [openStockVariant, setOpenStockVariant] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [updatedId, setUpdatedId] = useState("");
  const handleCloseDelete = () => setOpenDelete(false);
  const { auth } = useAuth();
  const getId = auth.user ? auth.user.id : "";
  const hakAkses = auth.user ? auth.user.accessRight : null;
  // const sizes = ["XS", "S", "M", "L", "XL"];
  const [openSorting, setOpenSorting] = useState(false);
  const [sortedData, setSortedData] = useState([]);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(12);
  const [totalItem, setTotalItem] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingImage, setLoadingImage] = useState(false);
  const [loadingSizeChart, setLoadingSizeChart] = useState(false);

  const [search, setSearch] = useState(null);
  const [filterPartner, setFilterPartner] = useState(null);
  const [filterState, setFilterState] = useState('-');
  const [openFilter, setOpenFilter] = useState(false);
  const [inputTagMainFilter, setInputTagMainFilter] = useState([]);
  const [inputTagSecondaryFilter, setInputTagSecondaryFilter] = useState([]);
  const [inputBrandFilter, setInputBrandFilter] = useState([]);
  const [filterStock, setFilterStock] = useState('-');
  const filterStateArr = [
    {title: 'All', value: '-'},
    {title: 'Active', value: 'A'},
    {title: 'Draft', value: 'D'},
  ];
  const filterStockArr = [
    {title: 'All', value: '-'},
    {title: 'Available', value: 'AVAILABLE'},
    {title: 'Partial Stock', value: 'PARTIAL'},
    {title: 'No Stock', value: 'EMPTY'},
  ];

  // Fungsi untuk mengubah size
  const handleSizeChange = (e, index) => {
    const newStockVariants = [...stockVariants];
    newStockVariants[index].size = e.target.value;
    setStockVariants(newStockVariants);
  };

  // Fungsi untuk mengubah quantity
  const handleQuantityChange = (e, index) => {
    const newStockVariants = [...stockVariants];
    newStockVariants[index].quantity = parseInt(e.target.value, 10);
    setStockVariants(newStockVariants);
  };

  const handleOrderChange = (e, index) => {
    const newStockVariants = [...stockVariants];
    newStockVariants[index].showOrder = parseInt(e.target.value, 10);
    setStockVariants(newStockVariants);
  }

  // Fungsi untuk menambah ukuran baru
  const handleAddSize = () => {
    setStockVariants([...stockVariants, { id: Date.now(), size: "", quantity: 0, showOrder: stockVariants.length + 1 }]); // Tambah entry kosong
  };

  // Fungsi untuk menghapus ukuran
  const handleRemoveSize = (index) => {
    if (stockVariants.length > 1) {
      setStockVariants(stockVariants.filter((_, i) => i !== index));
    }
  };

  const handleCloseSorting = () => {
    setOpenSorting(false);
    setSortedData([]);
  };
  const handleOpenSorting = () => {
    setSortedData(structuredClone(rows));
    setOpenSorting(true);
  };

  const handleDiscountTypeChange = (type) => {
    setDiscountType(type);
    if (type === 'N') {
      setDiscountAmount(0);
    }
  }

  const [tagMainList, setTagMainList] = useState([]);
  const [tagSecondaryList, setTagSecondaryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [stockVariants, setStockVariants] = useState([
    { size: '', quantity: '' }
  ]);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const generateStockString = () => {
    const stockObject = {};
    stockVariants.forEach((variant) => {
      if (variant.size && (variant.quantity !== '' || variant.quantity != null)) {
        stockObject[variant.size] = {
          quantity: parseInt(variant.quantity),
          order: parseInt(variant.showOrder)
        };
      }
    });
    // Convert the object to JSON string before sending
    return JSON.stringify(stockObject);
  };

  const validate = () => {
    let tempErrors = {};
    if (!name) {
      tempErrors.name = "Nama barang harus diisi";
    } else if (name.length > 255) {
      tempErrors.name = "Nama barang maksimal 25 karakter";
    }
    if (!tipeBarang) {
      tempErrors.tipeBarang = "Tipe barang harus diisi";
    }
    if (!customWeight) {
      tempErrors.customWeight = "Berat barang harus diisi";
    } else if (customWeight.length > 5) {
      tempErrors.customWeight = "Varian barang maksimal 25 karakter";
    }
    
    if (!customDefaultPrice) {
      tempErrors.customDefaultPrice = "Harga jual barang harus diisi";
    } else if (customDefaultPrice.length > 15) {
      tempErrors.customDefaultPrice = "Varian barang maksimal 25 karakter";
    }
    if (!description) {
      tempErrors.description = "Deskripsi barang harus diisi";
    }

    if (inputTagMain.length <= 0) {
      tempErrors.tagMain = "Tag Utama harus diisi";
    }

    if (!inputBrand) {
      tempErrors.brand = "Brand harus diisi";
    }

    if (discountAmount < 0) {
      tempErrors.discountAmount = "Potongan diskon tidak boleh negatif";
    }

    if (discountType === 'P' && parseInt(discountAmount) > 100) {
      tempErrors.discountAmount = "Potongan diskon tidak boleh lebih dari 100";
    }

    if (discountType === 'H' && parseInt(discountAmount) > parseInt(customDefaultPrice)) {
      tempErrors.discountAmount = "Potongan diskon tidak boleh lebih dari harga jual";
    }

    if (discountType !== 'N') {
      if (discountStart === null) {
        tempErrors.discountStart = "Tanggal start diskon harus diisi jika tipe diskon bukan None";
      }
  
      if (discountEnd === null) {
        tempErrors.discountEnd = "Tanggal end diskon harus diisi jika tipe diskon bukan None";
      }
    }

    if (!itemType) {
      tempErrors.itemType = "Tipe barang harus diisi"
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const compressOption = {
    maxSizeMB: 0.6,
    fileType: 'image/webp',
    initialQuality: 1,
  }

  const onDrop = useCallback(
    (acceptedFiles) => {
      console.log(files)

      // Handle the files
      const validFiles = acceptedFiles.filter((file) =>
        /\.(jpg|jpeg|png|gif)$/i.test(file.name)
      );
      console.log(acceptedFiles);
      if (validFiles.length > 0) {
        setShowMsgImage(false);
        setLoadingImage(true);
        const filePreviews = validFiles.map(async (file) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          return new Promise((resolve) => {
            reader.onload = () => {
              resolve({
                path: file.name,
                preview: reader.result,
                originalFile: file,
              });
            };
          });
        });

        Promise.all(filePreviews)
          .then((images) => {
            setFiles(prevFiles => [...prevFiles, ...images]);
          })
          .catch((error) => {
            console.error("Error reading files:", error);
          })
          .finally(() => {
            setLoadingImage(false);
          });
      } else {
        setShowMsgImage(true);
        setMsgImageError(
          "Invalid file types detected. Please upload only image files."
        );
        console.error(
          "Invalid file types detected. Please upload only image files."
        );
      }
    },
    [setFiles]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const onDropSizeChart = useCallback(
    (acceptedFiles) => {
      console.log("masuk sini")
      // Handle the files
      const validFiles = acceptedFiles.filter((file) =>
        /\.(jpg|jpeg|png|gif)$/i.test(file.name)
      );
      console.log(acceptedFiles);
      if (validFiles.length > 0) {
        setShowMsgSizeChart(false);
        setLoadingSizeChart(true);
        
        const filePreviews = validFiles.map(async (file) => {
          const compresedImage = await compressImageWebp(file, compressOption)

          const reader = new FileReader();
          reader.readAsDataURL(compresedImage);
          return new Promise((resolve) => {
            reader.onload = () => {
              resolve({
                path: compresedImage.name,
                preview: reader.result,
                originalFile: compresedImage,
              });
            };
          });
        });

        Promise.all(filePreviews)
          .then((images) => {
            setSizeChart(oldFiles => [...oldFiles, ...images]);
          })
          .catch((error) => {
            console.error("Error reading files:", error);
          })
          .finally(() => {
            setLoadingSizeChart(false);
          });
      } else {
        setShowMsgSizeChart(true);
        setMsgSizeChartError(
          "Invalid file types detected. Please upload only image files."
        );
        console.error(
          "Invalid file types detected. Please upload only image files."
        );
      }
    },
    [setSizeChart]
  );
  const { getRootProps: getSizeChartRootProps, getInputProps: getSizeChartInputProps, isDragActive: isSizeChartDragActive } = useDropzone({ onDrop: onDropSizeChart });

  const fetchDataInventori = async () => {
    try {
      const response = await InventoryService.fetchDataInventory(
        search, 
        hakAkses?.position === "Mitra" ? getId : filterPartner?.id, 
        hakAkses?.position === "Mitra" ? 'A' : (filterState === '-' ? '' : filterState),
        inputTagMainFilter.map((tag) => tag.id).join(","),
        inputTagSecondaryFilter.map((tag) => tag.id).join(","),
        inputBrandFilter.map((brand) => brand.id).join(","),
        filterStock === '-' ? '' : filterStock,
        page, 
        perPage
      );
      if (response) {
        const data = response.data;
        // console.log(response.data);
        setTotalItem(data.totalData);
        setTotalPage(data.totalPage);

        const itemList = data.itemList.map(item => {
          const mappedItem = { ...item }
          
          let hasDiscount = false;
          if (item.discountType !== 'N') {
            const today = new Date();
            const discStart = new Date(item.discountStart);
            const discEnd = new Date(item.discountEnd);
            discEnd.setDate(discEnd.getDate() + 1);
  
            hasDiscount = today >= discStart && today < discEnd;
          }
          mappedItem.hasDiscount = hasDiscount;

          return mappedItem;
        });

        setRows(itemList);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchDataTipeBarang = async () => {
    try {
      const response = await axios.get(`${backendUrl}/admin/daftarTipe`);
      console.log(response.data);
      setTypeData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getAllTag = async () => {
    try {
      const response = await TagService.getTagList("");
      if (response) {
        const data = response.data.tagModelList;
        setTagMainList(data.filter((tag) => tag.flag === "main"));
        setTagSecondaryList(data.filter((tag) => tag.flag === "secondary"));
        setBrandList(data.filter((tag) => tag.flag === "brand"));
      }
    } catch (error) {
      console.error(error);
      setMsgError("Error while fetching list tags");
      activateError();
    }
  };

  const getAllPartner = async () => {
    try {
      const response = await PartnerService.getListPartnerAll();
      if (response) {
        const data = response.data;
        setPartners(data.partnerList);
      }
    } catch (error) {
      console.error(error);
      setMsgError("Error while fetching list partner");
      activateError();
    }
  }

  useEffect(() => {
    setemployeeId(getId);
    fetchDataTipeBarang();
    fetchDataInventori();
    getAllTag();
    getAllPartner();
  }, [getId]);

  const optionsTipe = typeData.map((item) => ({
    label: item.varian,
    value: item.id,
    berat: item.weight,
  }));

  const handleAutocompleteChange = (event, newValue) => {
    console.log(newValue);
    settipeBarang(newValue);
    if (newValue) {
      setcustomWeight(newValue.berat.toString());
    } else {
      setcustomWeight("");
    }
  };

  const resetFields = () => {
    setErrors({});
    setname("");
    settipeBarang(null);
    setcustomWeight("");
    setcustomDefaultPrice(0);
    setFiles([]);
    setSizeChart([]);
    setDescription("");
    setInputTagMain([]);
    setInputTagSecondary([]);
    setDiscountType('N');
    setDiscountAmount(0);
    setDiscountStart(null);
    setDiscountEnd(null);
    setInputBrand(null);
    setInputPartner(null);
    setItemType("S");
    setShopeeLink("");
    setTiktokLink("");
    setFinalPrice(0);
    setItemState("A");
    setStockVariants([
      { size: '', quantity: '' }
    ]);
    setItemLabels([]);
    setItemLabelText("");
  }

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setOpen(false);
      resetFields();
    }
  };

  const handleSubmit = async (e, state) => {
    e.preventDefault();
    if (validate()) {
      const typeId = tipeBarang.value;

      const formData = new FormData();
      formData.append("name", name);
      formData.append("typeId", typeId);
      formData.append("employeeId", employeeId);
      formData.append("customWeight", customWeight);
      formData.append("customCapitalPrice", 0);
      formData.append("customDefaultPrice", customDefaultPrice);
      formData.append("stockVariant", generateStockString());
      formData.append("description", description);
      formData.append("partnerId", inputPartner?.id || '');
      formData.append(
        "tagMainId",
        inputTagMain.map((tag) => tag.id)
      );
      formData.append(
        "tagSecondaryId",
        inputTagSecondary.map((tag) => tag.id)
      );
      formData.append("brandId", inputBrand?.id);
      formData.append("discountType", discountType);
      formData.append("discountAmount", discountAmount);
      formData.append("discountStart", discountStart && discountType !== 'N'  ? discountStart.format("YYYY-MM-DD HH:mm") : '');
      formData.append("discountEnd", discountEnd && discountType !== 'N'  ? discountEnd.format("YYYY-MM-DD HH:mm") : '');
      formData.append("itemType", itemType);
      formData.append("shopeeLink", shopeeLink);
      formData.append("tiktokLink", tiktokLink);
      formData.append("itemState", state);
      formData.append("itemLabels", itemLabels);

      if (files && files.length > 0) {
        for (const file of files) {
          const compressed = await compressImageWebp(file.originalFile);
          console.log(compressed)
          formData.append("files", compressed);
        }
      }

      if (sizeChart && sizeChart.length > 0) {
        Array.from(sizeChart).forEach((file) => {
          formData.append("sizeChart", file.originalFile);
        });
      }
      console.log([...formData]);

      try {
        setLoading(true);
        const response = await axios.post(
          `${backendUrl}/admin/tambahInventori`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log(response.data);
        setShowSuccess(true);
        setmsgSuccess("Berhasil Menambah Item Barang");
        setTimeout(() => {
          setShowSuccess(false);
        }, 5000);
        fetchDataInventori();
        resetFields();
      } catch (error) {
        setErrors(error.response);
        setShowError(true);
        setMsgError("Gagal Menambah Item Barang");
        setTimeout(() => {
          setShowError(false);
        }, 5000);
      } finally {
        setLoading(false);
      }
      setOpen(false);
    } else {
      console.log("Validation failed");
    }
  };

  const handleOpenStockVariant = (row) => {
    setUpdatedId(row.id);
    setStockVariants(row.stockVariant);
    setOpenStockVariant(true) 
  };

  const handleCloseStockVariant = (_e, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setOpenStockVariant(false);
      setUpdatedId(null);
      setStockVariants([]);
    }
  };

  const handleOpenEdit = (row) => {
    setUpdatedId(row.id);
    setname(row.nama);
    settipeBarang(
      optionsTipe.find((option) => option.value === row.idJenisBarang)
    );
    setcustomWeight(row.customWeight);
    setcustomDefaultPrice(row.customDefaultPrice);
    setFiles(row.files || []);
    // setOldFiles(row.files || []);
    setDescription(row.description);
    setStockVariants(row.stockVariant);
    setInputBrand(row.brand);
    setInputTagMain(row.tagMain);
    setInputTagSecondary(row.tagSecondary);
    setSizeChart(row.sizeChart || []);
    // setOldSizeChart(row.sizeChart || []);
    setDiscountType(row.discountType || 'N');
    setDiscountAmount(row.discountAmount);
    setDiscountStart(row.discountStart == null ? null : dayjs(row.discountStart)); 
    setDiscountEnd(row.discountEnd == null ? null : dayjs(row.discountEnd));
    setInputPartner(row.partner);
    setItemType(row.itemType);
    setShopeeLink(row.shopeeLink);
    setTiktokLink(row.tiktokLink);
    setItemState(row.itemState);
    setItemLabels(row.itemLabels || []);
    calculateFinalPrice();
    setOpenEdit(true);
  };

  const handleCloseEdit = (e, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setOpenEdit(false);
      resetFields();
    }
  };

  const handleConfirmEdit = async (e, state = "A") => {
    e.preventDefault();
    if (validate()) {
      try {
        const typeId = tipeBarang.value;
        const formData = new FormData();
        formData.append("name", name);
        formData.append("id", updatedId);
        formData.append("typeId", typeId);
        formData.append("customWeight", customWeight);
        formData.append("customCapitalPrice", 0);
        formData.append("customDefaultPrice", customDefaultPrice);
        formData.append("stockVariant", generateStockString());
        formData.append("description", description);
        formData.append(
          "tagMainId",
          inputTagMain.map((tag) => tag.id)
        );
        formData.append(
          "tagSecondaryId",
          inputTagSecondary.map((tag) => tag.id)
        );
        formData.append("brandId", inputBrand?.id);
        formData.append("discountType", discountType);
        formData.append("discountAmount", discountAmount);
        formData.append("discountStart", discountStart && discountType !== 'N'  ? discountStart.format("YYYY-MM-DD HH:mm") : '');
        formData.append("discountEnd", discountEnd && discountType !== 'N'  ? discountEnd.format("YYYY-MM-DD HH:mm") : '');
        formData.append("partnerId", inputPartner?.id || '');
        formData.append("itemType", itemType);
        formData.append("shopeeLink", shopeeLink);
        formData.append("tiktokLink", tiktokLink);
        formData.append("itemState", state);
        formData.append("itemLabels", itemLabels);

        const uploadedFiles = [];
        let fileIndex = 0;
        for (const file of files) {
          if (typeof file == "string") {
            uploadedFiles.push({ type: "existing", filename: file });
          } else {
            const compressed = await compressImageWebp(file.originalFile);
            console.log(compressed)
            const fieldName = `file${fileIndex}`;
            formData.append(fieldName, compressed);
            uploadedFiles.push({ type: "new", filename: fieldName });
  
            fileIndex++;
          }
        }
        formData.append("uploadedFile", JSON.stringify(uploadedFiles));

        const uploadedSizeChart = [];
        let sizeChartIndex = 0;
        Array.from(sizeChart).forEach((file) => {
          if (typeof file == "string") {
            uploadedSizeChart.push({ type: "existing", filename: file });
          } else {
            const fieldName = `sizeChart${sizeChartIndex}`;
            formData.append(fieldName, file.originalFile);
            uploadedSizeChart.push({ type: "new", filename: fieldName });

            sizeChartIndex++;
          }
        });
        formData.append("uploadedSizeChart", JSON.stringify(uploadedSizeChart));
        
        // oldFiles.forEach((file) => {
        //   formData.append("oldFiles[]", file);
        // });
        // oldSizeChart.forEach((file) => {
        //   formData.append("oldSizeChart[]", file);
        // });
        
        setLoading(true);
        const response = await axios.post(
          `${backendUrl}/admin/editInventori`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log(response.data);
        setShowSuccess(true);
        setmsgSuccess("Berhasil Mengubah Data Barang");
        setTimeout(() => {
          setShowSuccess(false);
        }, 5000);
        fetchDataInventori();
        resetFields();
      } catch (error) {
        setShowError(true);
        setMsgError("Gagal Mengubah Data Barang");
        setTimeout(() => {
          setShowError(false);
        }, 5000);
      } finally {
        setLoading(false);
      }
      setOpenEdit(false);
    } else {
      console.log("Validation failed");
    }
  };

  const updateStockVariant = async () => {
    try {
      setLoading(true);
      const dataStockVariant = generateStockString();
      const response = await InventoryService.updateStockVariant(updatedId, dataStockVariant);
      if (response) {
        setShowSuccess(true);
        setmsgSuccess("Berhasil Mengubah Data Barang");
        setTimeout(() => {
          setShowSuccess(false);
        }, 5000);
        fetchDataInventori();
        handleCloseStockVariant(null, null);
      }

    } catch (error) {
      console.error(error);
      setShowError(true);
      setMsgError("Gagal Mengubah Data Barang");
      setTimeout(() => {
        setShowError(false);
      }, 5000);
    } finally {
      setLoading(false);
    }
  }

  const handleDeleteOldFiles = (deletedFile) => {
    setOldFiles(oldFiles.filter((file) => file !== deletedFile));
  };

  const handleDeleteOldSizeChart = (deletedFile) => {
    setOldSizeChart(oldSizeChart.filter((file) => file !== deletedFile));
  };

  const handleDeleteUploadedFile = (file, index) => {
    setFiles(files.filter((_, i) => i !== index));
  }

  const handleImageCropped = (croppedImage, index, originalItem) => {
    const updatedFiles = [...files];
    if (typeof updatedFiles[index] == "string") {
      const croppedFile = base64ToFile(croppedImage, files[index], "image/png");
      updatedFiles[index] = {
        path: updatedFiles[index],
        originalFile: croppedFile,
        preview: URL.createObjectURL(croppedFile),
        baseFile: originalItem,
      };
    } else {
      const croppedFile = base64ToFile(croppedImage, files[index].originalFile.name, "image/png");
      updatedFiles[index] = {
        path: updatedFiles[index].path,
        originalFile: croppedFile,
        preview: URL.createObjectURL(croppedFile),
        baseFile: updatedFiles[index].baseFile ? updatedFiles[index].baseFile : originalItem,
      };
    }
    setFiles(updatedFiles);
  }

  const handleDeleteSizeChart = (file, index) => {
    setSizeChart(sizeChart.filter((_, i) => i !== index));
  }

  const handleOpenDelete = (row) => {
    setUpdatedId(row.id);
    console.log(row.id);
    setOpenDelete(true);
  };

  const handleConfirmDelete = async (e) => {
    e.preventDefault();
    try {
      // const id = updatedId;
      const response = await axios.delete(
        `${backendUrl}/admin/deleteInventori/${updatedId}`
      );
      console.log(response.data);
      fetchDataInventori();
      setShowSuccess(true);
      setmsgSuccess("Berhasil Hapus Data Barang");
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
    } catch (error) {
      console.error(error);
      setMsgError("Gagal Hapus Data Barang");
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 5000);
    }
    setOpenDelete(false);
  };

  const handleSubmitSorting = async () => {
    try {
      const updatedItemSorting = sortedData.filter(
        (data) => data.updated === true
      );
      const data = updatedItemSorting.map((item) => {
        return {
          id: item.id,
          showOrder: item.showOrder,
        };
      });
      console.log(data);

      const response = await axios.patch(
        `${backendUrl}/admin/updateShowOrder`,
        data
      );

      if (response) {
        fetchDataInventori();
        setmsgSuccess("Berhasil Ubah Urutan Barang");
        activateSuccess();
      }
    } catch (error) {
      console.error(error);
      setMsgError("Gagal Ubah Urutan Barang");
      activateError();
    }

    handleCloseSorting();
  };

  const calculateFinalPrice = () => {
    let price = customDefaultPrice;
    
    if (discountType === 'P') {
      price = customDefaultPrice - (customDefaultPrice * discountAmount) / 100;
    } else if (discountType === 'H') {
      price = customDefaultPrice - discountAmount
    }

    setFinalPrice(Math.round(price));
  }

  const handleKeyDownLabel = (e) => {
    if (itemLabeltext && (e.key === "Enter" || e.key === "Tab" || e.key === " ")) {
      e.preventDefault();
      setItemLabelText(itemLabeltext.trim());
      const lowerLabel = itemLabeltext.trim().toLowerCase();
      const find = itemLabels.find(label => label === lowerLabel);
      if (find) {
        setMsgError("Label sudah ada");
        activateError();
      } else {
        setItemLabels([...itemLabels, lowerLabel]);
        setItemLabelText("");
      }
    }
  }

  const handleDeleteLabel = (label) => {
    setItemLabels(itemLabels.filter(item => item !== label));
  }

  const activateSuccess = () => {
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

  const activateError = () => {
    setShowError(true);
    setTimeout(() => {
      setShowError(false);
    }, 5000);
  };

  const searchTimeout = useRef(null);
  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      setPage(1);
      fetchDataInventori()
    }, 500);
    return () => clearTimeout(searchTimeout.current);
  }, [search, filterPartner, filterState, inputTagMainFilter, inputTagSecondaryFilter, inputBrandFilter, filterStock]);
  
  const resetFilter = () => {
    setSearch("");
    setFilterPartner(hakAkses?.position === "Mitra" ? getId : null);
    setFilterState(hakAkses?.position === "Mitra" ? 'A' : '-');
    setInputTagMainFilter([]);
    setInputTagSecondaryFilter([]);
    setInputBrandFilter([]);
    setFilterStock('-');
  }

  useEffect(() => {
    fetchDataInventori();
    window.scrollTo(0, 0);
  }, [page])

  useEffect(() => {
    calculateFinalPrice();
  }, [customDefaultPrice, discountType, discountAmount])

  return (
    <Box>
      <CssBaseline />
      <AdminNavigation />
      <Container
        component="main"
        maxWidth="xl"
      >
        <RootContainer>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={showSuccess}
            autoHideDuration={3000}
            onClose={() => setShowSuccess(false)}
          >
            <SnackbarContent
              sx={{ backgroundColor: "#19B600" }} 
              message={msgSuccess}/>
          </Snackbar>
    
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={showError}
            autoHideDuration={3000}
            onClose={() => setShowError(false)}
          >
            <SnackbarContent 
              sx={{ backgroundColor: "#E50B0B" }} 
              message={msgError}/>
          </Snackbar>

          <Grid container spacing={1} alignItems="center" justifyContent="space-between" marginBottom={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...headerStyleContrast }}>
                Kelola Produk
              </Typography>
            </Grid>
            <Grid item xs={6} sm={8} md={4}>
              <TextField
                fullWidth
                value={search}
                placeholder="Cari barang..."
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{ 
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchOutlinedIcon />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            {
              hakAkses?.position !== "Mitra" && (
                <Grid item xs={6} sm={4} md={2}>
                  <Button 
                    endIcon={<AddIcon sx={{ color: "white" }} />}
                    style={{ ...btnStyleContrast, borderRadius: "50px", width: "100%" }} 
                    onClick={handleOpen}>
                    Tambah Produk
                  </Button>
                </Grid>
              )
            }
          </Grid>
          
          {
            hakAkses?.position !== "Mitra" && (
              <Box marginBottom={2} width="100%" display="flex" justifyContent="end">
                <Button 
                  sx={{ ...btnStyleOutlined, borderRadius: "50px", color: "black" }} 
                  onClick={() => setOpenFilter(true)}
                  endIcon={<FilterIcon />}
                >
                  Filter
                </Button>
              </Box>
            )
          }

          {/* <Grid container justifyContent="end" marginBottom={1}>
            <Grid item xs={4} sm={4} md={3} lg={2} sx={{ textAlign: "right" }}>
              <Button
                style={styleButtonUpdateOrder}
                onClick={handleOpenSorting}
              >
                Ubah Urutan
              </Button>
            </Grid>
          </Grid> */}

          <Grid container sx={{ marginY: "20px" }} spacing={2}>
            {
              rows.map(item => (
                <Grid item key={item.id} xs={12} sm={6} md={4} lg={3}>
                  <Box position="relative" sx={{ 
                    background: "white", 
                    borderRadius: "16px", 
                    padding: "16px", 
                    marginBottom: "20px", 
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, .2)",
                    minHeight: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}>
                    <Box position="absolute" top="25px" right="25px">
                      <Chip label={itemStateArr.find(type => type.value === item.itemState)?.title || '-'} 
                        color={item.itemState === 'A' ? 'success' : 'default'} size="small"/>
                      {
                        (item.stockVariant || []).reduce((total, variant) => total + parseFloat(variant.quantity), 0) <= 0 
                        ? (
                            <Chip label="No Stock" color="error" size="small" sx={{ marginLeft: "5px" }}/>
                          ) 
                        : (item.stockVariant || []).some(variant => parseFloat(variant.quantity) <= 0) 
                          ? (
                              <Chip label="Partial Stock" color="warning" size="small" sx={{ marginLeft: "5px" }}/>
                            ) 
                          : null
                      }
                    </Box>

                    <Grid container rowSpacing={0.5} columnSpacing={2} flexGrow="1">
                      <Grid item xs={12}>
                        <Box sx={{ aspectRatio: "4 / 5" }}>
                          <img
                            src={
                              item.files?.length <= 0 || item.files == null
                                ? noImage
                                : `${imageUrl}${item.files[0]}`
                            }
                            alt={item.nama}
                            style={{
                              width: "100%",
                              aspectRatio: "4 / 5",
                              objectFit: "cover",
                              borderRadius: "16px"
                            }}
                          ></img>
                        </Box>
                      </Grid>
                      
                      <Grid item xs={12} display="flex" gap="20px" alignItems="center">
                        <Typography sx={{ ...textStyleContrast, color: lightergrayHex }} display="flex" alignItems="center" gap="10px">
                          <CalendarTodayOutlinedIcon /> <span>Last Update: {item.lastupdate}</span>
                        </Typography>
                      </Grid>

                      <Grid item xs={12} display="flex" gap="5px" alignItems="center" flexWrap="wrap">
                        <Typography sx={{ ...textStyleContrast }}>
                          {item.itemcode}
                        </Typography>
                        <Chip label={itemTypeArr.find(type => type.value === item.itemType)?.title || '-'}></Chip>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography sx={{ ...textStyleLargeContrast, fontWeight: "500", minHeight: "60px", wordWrap: "break-word" }}>
                          {/* {`${item.nama.substring(0, 65)}${item.nama.length > 65 ? "..." : ""}`} */}
                          {item.nama}
                        </Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography sx={{ ...textSmallStyleContrast, color: lightergrayHex }}>
                          {item.jenisBarang} • {item.customWeight} g
                        </Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <Grid container spacing={0.5}>
                          <Grid item xs={6}>
                            <Typography sx={{ ...textSmallStyleContrast }}>
                              Harga Awal
                            </Typography>
                            <Typography sx={{ ...textStyleContrast, fontWeight: "500" }}>
                              <NumericFormat
                                value={item.customDefaultPrice}
                                displayType={"text"}
                                thousandSeparator="."
                                decimalSeparator=","
                                prefix={"Rp. "}
                              />
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography sx={{ ...textSmallStyleContrast }}>
                              Harga Jual
                            </Typography>
                            <Typography sx={{ ...textStyleContrast, fontWeight: "500" }}>
                              <NumericFormat
                                value={item.hasDiscount ? item.discountedPrice : item.customDefaultPrice}
                                displayType={"text"}
                                thousandSeparator="."
                                decimalSeparator=","
                                prefix={"Rp. "}
                              />
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography sx={{ ...textSmallStyleContrast }}>
                              Diskon
                            </Typography>
                            <Typography sx={{ ...textStyleContrast, fontWeight: "500" }}>
                              {
                                !item.hasDiscount ? "-" : (
                                  <>
                                  {
                                    item.discountType === 'N' && "-"
                                  }
                                  {
                                    item.discountType === 'P' && (
                                      <NumericFormat
                                        style={{ color: "red" }}
                                        value={item.discountAmount}
                                        allowNegative={false}
                                        displayType={"text"}
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        prefix="-"
                                        suffix={"%"}
                                      />
                                    )
                                  }
                                  {
                                    item.discountType === 'H' && (
                                      <NumericFormat
                                        style={{ color: "red" }}
                                        allowNegative={false}
                                        value={item.discountAmount}
                                        displayType={"text"}
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        prefix={"-Rp. "}
                                      />
                                    )
                                  }
                                  </>
                                )
                              }
                              
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>

                      {/* <Grid item xs={12} marginTop={1}>
                        <Box display="flex" gap="40px">
                          {
                            item.stockVariant?.map(stock => (
                              <Typography sx={textSmallStyleContrast} key={stock.id}>
                                {stock.size}: {stock.quantity}
                              </Typography>
                            ))
                          }
                        </Box>
                      </Grid> */}

                      {
                        hakAkses?.position !== "Mitra" ? (
                          <>
                            <Grid item xs={6} marginTop={2} alignSelf="flex-end">
                              <Button 
                                sx={{ ...btnStyleContrast, borderRadius: "50px", width: "100%" }}
                                endIcon={<EditOutlinedIcon />}
                                onClick={() => handleOpenEdit(item)}
                              >
                                Edit
                              </Button>
                            </Grid>
                            <Grid item xs={6} marginTop={2} alignSelf="flex-end">
                              <Button 
                                sx={{ ...btnStyleOutlined, borderRadius: "50px", width: "100%", color: "red", border: "1px solid red" }}
                                endIcon={<TrashIcon color="red" />}
                                onClick={() => handleOpenDelete(item)}
                              >
                                Delete
                              </Button>
                            </Grid>
                          </>
                        ) : (
                          <>
                            <Grid item xs={12} marginTop={2} display="flex" justifyContent="end" alignSelf="flex-end">
                              <Button 
                                sx={{ ...btnStyleContrast, borderRadius: "50px", width: "50%" }}
                                endIcon={<EditOutlinedIcon />}
                                onClick={() => handleOpenStockVariant(item)}
                              >
                                Edit Stok
                              </Button>
                            </Grid>
                          </>
                        )
                      }
                    </Grid>
                  </Box>
                </Grid>
              ))
            }

            <Box display="flex" justifyContent="center" sx={{ width: "100%" }} marginTop={3}>
              <Pagination sx={{ 
                  '& .MuiPaginationItem-root': {
                    color: 'black', 
                  },
                  '& .MuiPaginationItem-icon': {
                    color: 'black', 
                  },
                  '& .Mui-selected': {
                    backgroundColor: 'black !important', 
                    color: 'white', 
                  },
                }} 
                size="small"
                count={totalPage} 
                page={page}
                onChange={(_event, page) => setPage(page)} />
            </Box>

            {

            hakAkses?.position !== "Mitra" ? (
              <>
                {/* ini modal edit data */}
                <LiqueModal open={openEdit} onClose={handleCloseEdit} width="1500px" noPaddingY>
                  <form>
                    <Box paddingTop={2} paddingBottom={1} display="flex" justifyContent="space-between" alignItems="center"
                      sx={{ position: "sticky", top: "0px", background: "white", zIndex: "2" }}
                    >
                      <Typography sx={subHeaderStyleContrast}>Edit Produk</Typography>
                      <Button sx={roudedIconButtonStyle} onClick={() => handleCloseEdit(null, null)}>
                        <CloseIcon />
                      </Button>
                    </Box>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Typography>Nama Barang *</Typography>
                        <TextField
                          fullWidth
                          value={name}
                          error={!!errors.name}
                          helperText={errors.name}
                          FormHelperTextProps={{ sx: { color: "red" } }}
                          onChange={(e) => setname(e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Varian Barang *</Typography>
                        <Autocomplete
                          fullWidth
                          options={optionsTipe}
                          getOptionLabel={(option) => option.label}
                          getOptionSelected={(option, value) =>
                            option.value === value
                          }
                          renderInput={(params) => <TextField {...params} />}
                          value={optionsTipe.find(
                            (option) => option.value === tipeBarang?.value
                          )}
                          error={!!errors.tipeBarang}
                          helperText={errors.tipeBarang}
                          FormHelperTextProps={{ sx: { color: "red" } }}
                          onChange={handleAutocompleteChange}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Berat Barang (g) *</Typography>
                        <NumericFormat
                          fullWidth
                          autoComplete="off"
                          value={customWeight}
                          onValueChange={(values) =>
                            setcustomWeight(values.floatValue)
                          }
                          thousandSeparator="."
                          decimalSeparator=","
                          customInput={TextField}
                          error={!!errors.customWeight}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="start">
                                g
                              </InputAdornment>
                            ),
                          }}
                          variant="outlined"
                        />
                        {!!errors.customWeight && (
                          <FormHelperText error sx={{ color: "red" }}>
                            {errors.customWeight}
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        <Typography marginBottom={2}>Ukuran Barang - Stok *</Typography>

                        {stockVariants.map((item, index) => (
                          <Grid
                            container
                            spacing={2}
                            key={index}
                            alignItems="center"
                            justifyContent="end"
                            marginBottom={2}
                          >
                            {/* Dropdown Ukuran */}
                            <Grid item xs={4}>
                              <TextField
                                fullWidth
                                type="text"
                                value={item.size}
                                onChange={(e) => handleSizeChange(e, index)}
                                label="Ukuran"
                              />
                            </Grid>

                            {/* Input Quantity */}
                            <Grid item xs={4} sm={3}>
                              <TextField
                                fullWidth
                                type="number"
                                value={item.quantity}
                                onChange={(e) => handleQuantityChange(e, index)}
                                label="Jumlah"
                              />
                            </Grid>
                            
                            {/* Input Order */}
                            <Grid item xs={4} sm={3}>
                              <TextField
                                fullWidth
                                type="number"
                                value={item.showOrder}
                                onChange={(e) => handleOrderChange(e, index)}
                                label="Urutan"
                              />
                            </Grid>

                            {/* Tombol Hapus */}
                            <Grid item xs={4} sm={2}>
                              <Button 
                                sx={{ 
                                  ...btnStyleOutlined, borderRadius: "50px", width: "100%", color: "red", border: "1px solid red",
                                  "&:disabled" : {
                                    color: "red",
                                    opacity: "0.2"
                                  }
                                }}
                                endIcon={<TrashIcon color="red" />}
                                onClick={() => handleRemoveSize(index)}
                                disabled={stockVariants.length === 1} 
                              >
                                Delete
                              </Button>
                            </Grid>
                          </Grid>
                        ))}

                        {/* Tombol Tambah */}
                        <Button
                          sx={{ ...btnStyleContrast, borderRadius: "50px", width: "200px"}}
                          onClick={handleAddSize}
                          marginTop={1}
                          endIcon={<AddIcon />}
                        >
                          Tambah Ukuran
                        </Button>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Tag Utama *</Typography>
                        <Autocomplete
                          multiple
                          options={tagMainList}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.title}
                          value={[...inputTagMain]}
                          isOptionEqualToValue={(option, value) => {
                            return option.id === value.id;
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                          onChange={(event, newValue) =>
                            setInputTagMain(newValue)
                          }
                        />
                        {!!errors.tagMain ? (
                          <FormHelperText sx={{ color: "red" }}>
                            {errors.tagMain}
                          </FormHelperText>
                        ) : null}
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Tag Sekunder *</Typography>
                        <Autocomplete
                          multiple
                          options={tagSecondaryList}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.title}
                          value={[...inputTagSecondary]}
                          isOptionEqualToValue={(option, value) => {
                            return option.id === value.id;
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                          onChange={(event, newValue) =>
                            setInputTagSecondary(newValue)
                          }
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Label</Typography>
                        <TextField
                          sx={{ marginBottom: "5px" }}
                          fullWidth
                          value={itemLabeltext}
                          onChange={(e) => setItemLabelText(e.target.value?.trim())}
                          onKeyDown={(e) => handleKeyDownLabel(e)}
                          placeholder="Tekan Enter/Spasi/Tab untuk menambahkan label"
                        />
                        {
                          itemLabels.map(label => (
                            <Chip label={label} key={label} onDelete={() => handleDeleteLabel(label)} sx={{ marginBottom: "5px", marginRight: "5px" }} />
                          ))
                        }
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Brand *</Typography>
                        <Autocomplete
                          options={brandList}
                          getOptionLabel={(option) => option.title}
                          value={inputBrand ? { ...inputBrand } : null}
                          isOptionEqualToValue={(option, value) => {
                            return option.id === value.id;
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                          onChange={(event, newValue) =>
                            setInputBrand(newValue)
                          }
                        />
                        {!!errors.brand ? (
                          <FormHelperText sx={{ color: "red" }}>
                            {errors.brand}
                          </FormHelperText>
                        ) : null}
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Mitra</Typography>
                        <Autocomplete
                          options={partners}
                          getOptionLabel={(option) => option.name}
                          value={inputPartner ? { ...inputPartner } : null}
                          isOptionEqualToValue={(option, value) => {
                            return option.id === value.id;
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                          onChange={(event, newValue) =>
                            setInputPartner(newValue)
                          }
                        />
                        {!!errors.partner ? (
                          <FormHelperText sx={{ color: "red" }}>
                            {errors.partner}
                          </FormHelperText>
                        ) : null}
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Harga Jual Barang (Rp.) *</Typography>
                        <NumericFormat
                          fullWidth
                          autoComplete="off"
                          value={customDefaultPrice}
                          onValueChange={(values) =>
                            setcustomDefaultPrice(values.floatValue)
                          }
                          thousandSeparator="."
                          decimalSeparator=","
                          customInput={TextField}
                          error={!!errors.customDefaultPrice}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                Rp{" "}
                              </InputAdornment>
                            ),
                          }}
                          variant="outlined"
                        />
                        {!!errors.customDefaultPrice && (
                          <FormHelperText error sx={{ color: "red" }}>
                            {errors.customDefaultPrice}
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Tipe Diskon (Rp.) *</Typography>
                        <TextField
                          fullWidth
                          select
                          value={discountType}
                          onChange={(e) => handleDiscountTypeChange(e.target.value)}
                        >
                          {discountTypeArr.map((type) => (
                            <MenuItem key={type.value} value={type.value}>
                              {type.title}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Potongan Diskon*</Typography>
                        <NumericFormat
                          fullWidth
                          autoComplete="off"
                          value={discountAmount}
                          onValueChange={(values) => setDiscountAmount(values.floatValue)}
                          thousandSeparator="."
                          decimalSeparator=","
                          customInput={TextField}
                          error={!!errors.discountAmount}
                          InputProps={{
                            startAdornment: discountType === 'H' ? (
                              <InputAdornment position="start">
                                Rp{" "}
                              </InputAdornment>
                            ) : null,
                            endAdornment: discountType === 'P' ? (
                              <InputAdornment position="start">
                                {" "}%
                              </InputAdornment>
                            ) : null
                          }}
                          disabled={discountType === 'N'}
                          variant="outlined"
                        />
                        {!!errors.discountAmount && (
                          <FormHelperText error sx={{ color: "red" }}>
                            {errors.discountAmount}
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Harga Akhir (Rp.)</Typography>
                        <NumericFormat
                          disabled
                          fullWidth
                          autoComplete="off"
                          value={finalPrice}
                          thousandSeparator="."
                          decimalSeparator=","
                          customInput={TextField}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                Rp{" "}
                              </InputAdornment>
                            ),
                          }}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>Tanggal Start Diskon</Typography>
                        <Grid container columnSpacing={2}>
                          <Grid item xs={6} sm={7} md={8}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DateTimePicker
                                sx={{ width: "100%" }}
                                value={discountStart}
                                onChange={(newValue) => setDiscountStart(newValue)}
                                renderInput={(params) => <TextField fullWidth {...params} />}
                              />
                            </LocalizationProvider>
                          </Grid>
                          <Grid item xs={6} sm={5} md={4} display="flex" align-items="center">
                            <Button 
                              sx={{ ...btnStyleContrast, borderRadius: "50px", width: "100%"}} 
                              onClick={ () => setDiscountStart(dayjs(new Date())) }
                            >
                              Now
                            </Button>
                          </Grid>
                        </Grid>
                        {!!errors.discountStart && (
                          <FormHelperText error sx={{ color: "red" }}>
                            {errors.discountStart}
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>Tanggal End Diskon</Typography>
                        <Grid container columnSpacing={2}>
                          <Grid item xs={6} sm={7} md={8}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DateTimePicker
                                sx={{ width: "100%" }}
                                value={discountEnd}
                                onChange={(newValue) => setDiscountEnd(newValue)}
                                renderInput={(params) => <TextField fullWidth {...params} />}
                              />
                            </LocalizationProvider>
                          </Grid>
                          <Grid item xs={6} sm={5} md={4} display="flex" align-items="center">
                            <Button 
                              sx={{ ...btnStyleContrast, borderRadius: "50px", width: "100%"}} 
                              onClick={ () => setDiscountEnd(dayjs(new Date())) }
                            >
                              Now
                            </Button>
                          </Grid>
                        </Grid>
                        {!!errors.discountEnd && (
                          <FormHelperText error sx={{ color: "red" }}>
                            {errors.discountEnd}
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Deskripsi Barang *</Typography>
                        <TextareaAutosize
                          style={{ width: "100%" }}
                          minRows={3}
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                        />
                        {!!errors.description ? (
                          <FormHelperText sx={{ color: "red" }}>
                            {errors.description}
                          </FormHelperText>
                        ) : null}
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Link Affiliate Shopee</Typography>
                        <TextField
                          fullWidth
                          value={shopeeLink}
                          error={!!errors.shopeeLink}
                          helperText={errors.shopeeLink}
                          FormHelperTextProps={{ sx: { color: "red" } }}
                          onChange={(e) => setShopeeLink(e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Tipe Layanan *</Typography>
                        <TextField
                          fullWidth
                          select
                          value={itemType}
                          onChange={(e) => setItemType(e.target.value)}
                        >
                          {itemTypeArr.map((type) => (
                            <MenuItem key={type.value} value={type.value}>
                              {type.title}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Foto Produk</Typography>
                        <Typography sx={{ color: lightergrayHex }}>Pastikan format foto JPG, PNG, JPEG</Typography>
                        <Box
                          {...getRootProps()}
                          marginTop={1}
                          sx={{
                            border: "2px solid #aaa",
                            borderRadius: "14px",
                            padding: "20px",
                            textAlign: "center",
                            cursor: "pointer",
                            backgroundColor: isDragActive
                              ? "#f0f0f0"
                              : "#fafafa",
                            transition: "background-color 0.2s",
                            width: "150px",
                            height: "150px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <input {...getInputProps()} />
                          {isDragActive ? (
                            <Typography>Letakkan file disini</Typography>
                          ) : (
                            <Box display="flex" flexDirection="column" justifyContent="center" alignContent="center">
                              <AddIcon sx={{ margin: "auto" }} />
                              <Typography>Tambah Foto</Typography>
                            </Box>
                          )}
                        </Box>
                        <Box
                          mt={2}
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                          }}
                        >
                          <DndProvider backend={HTML5Backend}>
                            <UploadImageSortableList 
                              cropable={true}
                              images={files}
                              setImages={setFiles}
                              deleteItem={handleDeleteUploadedFile}
                              replaceIitem={handleImageCropped}
                              cropAcpectRatio={4 / 5}
                            />
                          </DndProvider>
                        </Box>
                        {showMsgImage && (
                          <Typography sx={{ color: "red" }}>
                            {msgImageError}
                          </Typography>
                        )}
                        {
                          loadingImage && (
                            <Typography>
                              Sedang mengkompres gambar, mohon menunggu...
                            </Typography>
                          )
                        }
                      </Grid>
                      {/* <Grid item xs={12}>
                        <Typography>Gambar Sekarang</Typography>
                        <DndProvider backend={HTML5Backend}>
                          <ImageSortableList
                            images={oldFiles}
                            setImages={setOldFiles}
                            alt={name}
                            deleteItem={handleDeleteOldFiles}
                          />
                        </DndProvider>
                        <Grid container spacing={2} marginTop={0}>
                          {oldFiles.length <= 0 ? (
                            <Grid item xs={12} textAlign="center">
                              Belum ada Gambar
                            </Grid>
                          ) : null}
                        </Grid>
                      </Grid> */}
                      <Grid item xs={12}>
                        <Typography>Upload Size Chart</Typography>
                        <Typography sx={{ color: lightergrayHex }}>Pastikan format foto JPG, PNG, JPEG</Typography>
                        <Box
                          {...getSizeChartRootProps()}
                          marginTop={1}
                          sx={{
                            border: "2px solid #aaa",
                            borderRadius: "14px",
                            padding: "20px",
                            textAlign: "center",
                            cursor: "pointer",
                            backgroundColor: isSizeChartDragActive ? "#f0f0f0" : "#fafafa",
                            transition: "background-color 0.2s",
                            width: "150px",
                            height: "150px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <input {...getSizeChartInputProps()} />
                          {isSizeChartDragActive ? (
                            <Typography>Letakkan file disini</Typography>
                          ) : (
                            <Box display="flex" flexDirection="column" justifyContent="center" alignContent="center">
                              <AddIcon sx={{ margin: "auto" }} />
                              <Typography>Tambah Size Chart</Typography>
                            </Box>
                          )}
                        </Box>
                        <Box
                          mt={2}
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                          }}
                        >
                          <DndProvider backend={HTML5Backend}>
                            <UploadImageSortableList 
                              images={sizeChart}
                              setImages={setSizeChart}
                              deleteItem={handleDeleteSizeChart}
                            />
                          </DndProvider>
                        </Box>
                        {showMsgSizeChart && (
                          <Typography sx={{ color: "red" }}>
                            {msgSizeChartError}
                          </Typography>
                        )}
                        {
                          loadingSizeChart && (
                            <Typography>
                              Sedang mengkompres gambar, mohon menunggu...
                            </Typography>
                          )
                        }
                      </Grid>
                      {/* <Grid item xs={12}>
                        <Typography>Size Chart Sekarang</Typography>
                        <DndProvider backend={HTML5Backend}>
                          <ImageSortableList
                            images={oldSizeChart}
                            setImages={setOldSizeChart}
                            alt={name}
                            deleteItem={handleDeleteOldSizeChart}
                          />
                        </DndProvider>
                        <Grid container spacing={2} marginTop={0}>
                          {oldSizeChart.length <= 0 ? (
                            <Grid item xs={12} textAlign="center">
                              Belum ada Gambar
                            </Grid>
                          ) : null}
                        </Grid>
                      </Grid> */}
                    </Grid>
                    <Box display="flex" justifyContent="end" gap="5px" paddingY={1}
                      style={{ position: "sticky", bottom: "0", background: "white" }}
                    >
                      <Button
                        sx={{ ...btnStyleContrastGray, borderRadius: "50px", width: "200px"}}
                        onClick={(e) => handleConfirmEdit(e, "D")}
                        marginTop={1}
                        endIcon={<DraftsIcon />}
                        disabled={loading}
                      >
                        { loading ? 'Mohon menunggu...' :  'Draft' }
                      </Button>
                      <Button
                        sx={{ ...btnStyleContrast, borderRadius: "50px", width: "200px"}}
                        onClick={(e) => handleConfirmEdit(e, "A")}
                        marginTop={1}
                        disabled={loading}
                      >
                        { loading ? 'Mohon menunggu...' :  'Save' }
                      </Button>
                    </Box>
                  </form>
                </LiqueModal>

                {/* ini modal delete data */}
                <LiqueModal open={openDelete} onClose={handleCloseDelete} width="500px">
                  <Box textAlign="center">
                    <Typography
                      id="spring-modal-title"
                      variant="h6"
                      component="h2"
                    >
                      Apakah kamu yakin ingin membuang data ini?
                    </Typography>
                    <Box sx={{ mt: 2 }}>
                      <Button variant="outlined" onClick={handleCloseDelete}>
                        Tidak
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={handleConfirmDelete}
                        sx={{ ml: 2, backgroundColor: "red", color: "white" }}
                      >
                        Buang
                      </Button>
                    </Box>
                  </Box>
                </LiqueModal>

                {/* ini modal insert data */}
                <LiqueModal open={open} onClose={handleClose} width="1500px" noPaddingY>
                  <form>
                    <Box paddingTop={2} paddingBottom={1} display="flex" justifyContent="space-between" alignItems="center"
                      sx={{ position: "sticky", top: "0px", background: "white", zIndex: "2" }}
                    >
                      <Typography sx={subHeaderStyleContrast}>Tambah Produk</Typography>
                      <Button sx={roudedIconButtonStyle} onClick={() => handleClose(null, null)}>
                        <CloseIcon />
                      </Button>
                    </Box>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Typography>Nama Barang *</Typography>
                        <TextField
                          fullWidth
                          value={name}
                          error={!!errors.name}
                          helperText={errors.name}
                          FormHelperTextProps={{ sx: { color: "red" } }}
                          onChange={(e) => setname(e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Varian Barang *</Typography>
                        <Autocomplete
                          fullWidth
                          options={optionsTipe}
                          getOptionLabel={(option) => option.label}
                          getOptionSelected={(option, value) =>
                            option.value === value
                          }
                          renderInput={(params) => <TextField {...params} />}
                          value={optionsTipe.find(
                            (option) => option.value === tipeBarang?.value
                          )}
                          error={!!errors.tipeBarang}
                          helperText={errors.tipeBarang}
                          FormHelperTextProps={{ sx: { color: "red" } }}
                          onChange={handleAutocompleteChange}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Berat Barang (g) *</Typography>
                        <NumericFormat
                          fullWidth
                          autoComplete="off"
                          value={customWeight}
                          onValueChange={(values) =>
                            setcustomWeight(values.floatValue)
                          }
                          thousandSeparator="."
                          decimalSeparator=","
                          customInput={TextField}
                          error={!!errors.customWeight}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="start">g</InputAdornment>
                            ),
                          }}
                          variant="outlined"
                        />
                        {!!errors.customWeight && (
                          <FormHelperText error sx={{ color: "red" }}>
                            {errors.customWeight}
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        <Typography marginBottom={2}>Ukuran Barang - Stok*</Typography>

                        {stockVariants.map((item, index) => (
                          <Grid
                            container
                            spacing={2}
                            key={index}
                            alignItems="center"
                            justifyContent="end"
                            marginBottom={2}
                          >
                            {/* Dropdown Ukuran */}
                            <Grid item xs={4}>
                              <TextField
                                fullWidth
                                type="text"
                                value={item.size}
                                onChange={(e) => handleSizeChange(e, index)}
                                label="Ukuran"
                              />
                            </Grid>

                            {/* Input Quantity */}
                            <Grid item xs={4} sm={3}>
                              <TextField
                                fullWidth
                                type="number"
                                value={item.quantity}
                                onChange={(e) => handleQuantityChange(e, index)}
                                label="Jumlah"
                              />
                            </Grid>
                            
                            {/* Input Order */}
                            <Grid item xs={4} sm={3}>
                              <TextField
                                fullWidth
                                type="number"
                                value={item.showOrder}
                                onChange={(e) => handleOrderChange(e, index)}
                                label="Urutan"
                              />
                            </Grid>

                            {/* Tombol Hapus */}
                            <Grid item xs={4} sm={2}>
                              <Button 
                                sx={{ 
                                  ...btnStyleOutlined, borderRadius: "50px", width: "100%", color: "red", border: "1px solid red",
                                  "&:disabled" : {
                                    color: "red",
                                    opacity: "0.2"
                                  }
                                }}
                                endIcon={<TrashIcon color="red" />}
                                onClick={() => handleRemoveSize(index)}
                                disabled={stockVariants.length === 1} 
                              >
                                Delete
                              </Button>
                            </Grid>
                          </Grid>
                        ))}

                        {/* Tombol Tambah */}
                        <Button
                          sx={{ ...btnStyleContrast, borderRadius: "50px", width: "200px"}}
                          onClick={handleAddSize}
                          marginTop={1}
                          endIcon={<AddIcon />}
                        >
                          Tambah Ukuran
                        </Button>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography>Tag Utama *</Typography>
                        <Autocomplete
                          multiple
                          options={tagMainList}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.title}
                          value={[...inputTagMain]}
                          isOptionEqualToValue={(option, value) => {
                            return option.id === value.id;
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                          onChange={(event, newValue) =>
                            setInputTagMain(newValue)
                          }
                        />
                        {!!errors.tagMain ? (
                          <FormHelperText sx={{ color: "red" }}>
                            {errors.tagMain}
                          </FormHelperText>
                        ) : null}
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Tag Sekunder *</Typography>
                        <Autocomplete
                          multiple
                          options={tagSecondaryList}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.title}
                          value={[...inputTagSecondary]}
                          isOptionEqualToValue={(option, value) => {
                            return option.id === value.id;
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                          onChange={(event, newValue) =>
                            setInputTagSecondary(newValue)
                          }
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Label</Typography>
                        <TextField
                          sx={{ marginBottom: "5px" }}
                          fullWidth
                          value={itemLabeltext}
                          onChange={(e) => setItemLabelText(e.target.value?.trim())}
                          onKeyDown={(e) => handleKeyDownLabel(e)}
                          placeholder="Tekan Enter/Spasi/Tab untuk menambahkan label"
                        />
                        {
                          itemLabels.map(label => (
                            <Chip label={label} key={label} onDelete={() => handleDeleteLabel(label)} sx={{ marginBottom: "5px", marginRight: "5px" }} />
                          ))
                        }
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Brand *</Typography>
                        <Autocomplete
                          options={brandList}
                          getOptionLabel={(option) => option.title}
                          value={inputBrand ? { ...inputBrand } : null}
                          isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                          }
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                          onChange={(event, newValue) => setInputBrand(newValue)}
                        />
                        {!!errors.brand && (
                          <FormHelperText sx={{ color: "red" }}>
                            {errors.brand}
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Mitra</Typography>
                        <Autocomplete
                          options={partners}
                          getOptionLabel={(option) => option.name}
                          value={inputPartner ? { ...inputPartner } : null}
                          isOptionEqualToValue={(option, value) => {
                            return option.id === value.id;
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                          onChange={(event, newValue) =>
                            setInputPartner(newValue)
                          }
                        />
                        {!!errors.partner ? (
                          <FormHelperText sx={{ color: "red" }}>
                            {errors.partner}
                          </FormHelperText>
                        ) : null}
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Harga Jual Barang (Rp.) *</Typography>
                        <NumericFormat
                          fullWidth
                          autoComplete="off"
                          value={customDefaultPrice}
                          onValueChange={(values) =>
                            setcustomDefaultPrice(values.floatValue)
                          }
                          thousandSeparator="."
                          decimalSeparator=","
                          customInput={TextField}
                          error={!!errors.customDefaultPrice}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                Rp{" "}
                              </InputAdornment>
                            ),
                          }}
                          variant="outlined"
                        />
                        {!!errors.customDefaultPrice && (
                          <FormHelperText error sx={{ color: "red" }}>
                            {errors.customDefaultPrice}
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Tipe Diskon (Rp.) *</Typography>
                        <TextField
                          fullWidth
                          select
                          value={discountType}
                          onChange={(e) => handleDiscountTypeChange(e.target.value)}
                        >
                          {discountTypeArr.map((type) => (
                            <MenuItem key={type.value} value={type.value}>
                              {type.title}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Potongan Diskon*</Typography>
                        <NumericFormat
                          fullWidth
                          autoComplete="off"
                          value={discountAmount}
                          onValueChange={(values) => setDiscountAmount(values.floatValue)}
                          thousandSeparator="."
                          decimalSeparator=","
                          customInput={TextField}
                          error={!!errors.discountAmount}
                          InputProps={{
                            startAdornment: discountType === 'H' ? (
                              <InputAdornment position="start">
                                Rp{" "}
                              </InputAdornment>
                            ) : null,
                            endAdornment: discountType === 'P' ? (
                              <InputAdornment position="start">
                                {" "}%
                              </InputAdornment>
                            ) : null
                          }}
                          disabled={discountType === 'N'}
                          variant="outlined"
                        />
                        {!!errors.discountAmount && (
                          <FormHelperText error sx={{ color: "red" }}>
                            {errors.discountAmount}
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Harga Akhir (Rp.)</Typography>
                        <NumericFormat
                          disabled
                          fullWidth
                          autoComplete="off"
                          value={finalPrice}
                          thousandSeparator="."
                          decimalSeparator=","
                          customInput={TextField}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                Rp{" "}
                              </InputAdornment>
                            ),
                          }}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>Tanggal Start Diskon</Typography>
                        <Grid container columnSpacing={2}>
                          <Grid item xs={6} sm={7} md={8}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DateTimePicker
                                sx={{ width: "100%" }}
                                value={discountStart}
                                onChange={(newValue) => setDiscountStart(newValue)}
                                renderInput={(params) => <TextField fullWidth {...params} />}
                              />
                            </LocalizationProvider>
                          </Grid>
                          <Grid item xs={6} sm={5} md={4} display="flex" align-items="center">
                            <Button 
                              sx={{ ...btnStyleContrast, borderRadius: "50px", width: "100%"}} 
                              onClick={ () => setDiscountStart(dayjs(new Date())) }
                            >
                              Now
                            </Button>
                          </Grid>
                        </Grid>
                        {!!errors.discountStart && (
                          <FormHelperText error sx={{ color: "red" }}>
                            {errors.discountStart}
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>Tanggal End Diskon</Typography>
                        <Grid container columnSpacing={2}>
                          <Grid item xs={6} sm={7} md={8}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DateTimePicker
                                sx={{ width: "100%" }}
                                value={discountEnd}
                                onChange={(newValue) => setDiscountEnd(newValue)}
                                renderInput={(params) => <TextField fullWidth {...params} />}
                              />
                            </LocalizationProvider>
                          </Grid>
                          <Grid item xs={6} sm={5} md={4} display="flex" align-items="center">
                            <Button 
                              sx={{ ...btnStyleContrast, borderRadius: "50px", width: "100%"}} 
                              onClick={ () => setDiscountEnd(dayjs(new Date())) }
                            >
                              Now
                            </Button>
                          </Grid>
                        </Grid>
                        {!!errors.discountEnd && (
                          <FormHelperText error sx={{ color: "red" }}>
                            {errors.discountEnd}
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Deskripsi Barang *</Typography>
                        <TextareaAutosize
                          style={{ width: "100%" }}
                          minRows={3}
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                        />
                        {!!errors.description ? (
                          <FormHelperText sx={{ color: "red" }}>
                            {errors.description}
                          </FormHelperText>
                        ) : null}
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Link Affiliate Shopee</Typography>
                        <TextField
                          fullWidth
                          value={shopeeLink}
                          error={!!errors.shopeeLink}
                          helperText={errors.shopeeLink}
                          FormHelperTextProps={{ sx: { color: "red" } }}
                          onChange={(e) => setShopeeLink(e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Tipe Barang *</Typography>
                        <TextField
                          fullWidth
                          select
                          value={itemType}
                          onChange={(e) => setItemType(e.target.value)}
                        >
                          {itemTypeArr.map((type) => (
                            <MenuItem key={type.value} value={type.value}>
                              {type.title}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Foto Produk</Typography>
                        <Typography sx={{ color: lightergrayHex }}>Pastikan format foto JPG, PNG, JPEG</Typography>
                        <Box
                          {...getRootProps()}
                          marginTop={1}
                          sx={{
                            border: "2px solid #aaa",
                            borderRadius: "14px",
                            padding: "20px",
                            textAlign: "center",
                            cursor: "pointer",
                            backgroundColor: isDragActive ? "#f0f0f0" : "#fafafa",
                            transition: "background-color 0.2s",
                            width: "150px",
                            height: "150px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <input {...getInputProps()} />
                          {isDragActive ? (
                            <Typography>Letakkan file disini</Typography>
                          ) : (
                            <Box display="flex" flexDirection="column" justifyContent="center" alignContent="center">
                              <AddIcon sx={{ margin: "auto" }} />
                              <Typography>Tambah Foto</Typography>
                            </Box>
                          )}
                        </Box>
                        {!showMsgImage && (
                          <Box
                            mt={2}
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "wrap",
                            }}
                          >
                            <DndProvider backend={HTML5Backend}>
                              <UploadImageSortableList 
                                cropable={true}
                                images={files}
                                setImages={setFiles}
                                deleteItem={handleDeleteUploadedFile}
                                replaceIitem={handleImageCropped}
                                cropAcpectRatio={4 / 5}
                              />
                            </DndProvider>
                          </Box>
                        )}
                        {showMsgImage && (
                          <Typography sx={{ color: "red" }}>
                            {msgImageError}
                          </Typography>
                        )}
                        {
                          loadingImage && (
                            <Typography>
                              Sedang mengkompres gambar, mohon menunggu...
                            </Typography>
                          )
                        }
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Upload Size Chart</Typography>
                        <Typography sx={{ color: lightergrayHex }}>Pastikan format foto JPG, PNG, JPEG</Typography>
                        <Box
                          {...getSizeChartRootProps()}
                          marginTop={1}
                          sx={{
                            border: "2px solid #aaa",
                            borderRadius: "14px",
                            padding: "20px",
                            textAlign: "center",
                            cursor: "pointer",
                            backgroundColor: isSizeChartDragActive ? "#f0f0f0" : "#fafafa",
                            transition: "background-color 0.2s",
                            width: "150px",
                            height: "150px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <input {...getSizeChartInputProps()} />
                          {isSizeChartDragActive ? (
                            <Typography>Letakkan file disini</Typography>
                          ) : (
                            <Box display="flex" flexDirection="column" justifyContent="center" alignContent="center">
                              <AddIcon sx={{ margin: "auto" }} />
                              <Typography>Tambah Size Chart</Typography>
                            </Box>
                          )}
                        </Box>
                        {!showMsgSizeChart && (
                          <Box
                            mt={2}
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "wrap",
                            }}
                          >
                            <DndProvider backend={HTML5Backend}>
                              <UploadImageSortableList 
                                images={sizeChart}
                                setImages={setSizeChart}
                                deleteItem={handleDeleteSizeChart}
                              />
                            </DndProvider>
                          </Box>
                        )}
                        {showMsgSizeChart && (
                          <Typography sx={{ color: "red" }}>
                            {msgSizeChartError}
                          </Typography>
                        )}
                        {
                          loadingSizeChart && (
                            <Typography>
                              Sedang mengkompres gambar, mohon menunggu...
                            </Typography>
                          )
                        }
                      </Grid>
                    </Grid>
                    <Box display="flex" justifyContent="end" gap="5px" paddingY={1}
                      style={{ position: "sticky", bottom: "0", background: "white" }}
                    >
                      <Button
                        sx={{ ...btnStyleContrastGray, borderRadius: "50px", width: "200px"}}
                        onClick={(e) => handleSubmit(e, "D")}
                        marginTop={1}
                        endIcon={<DraftsIcon />}
                        disabled={loading}
                      >
                        { loading ? 'Mohon menunggu...' :  'Draft' }
                      </Button>
                      <Button
                        sx={{ ...btnStyleContrast, borderRadius: "50px", width: "200px"}}
                        onClick={(e) => handleSubmit(e, "A")}
                        marginTop={1}
                        endIcon={<AddIcon />}
                        disabled={loading}
                      >
                        { loading ? 'Mohon menunggu...' :  'Tambah' }
                      </Button>
                    </Box>
                  </form>
                </LiqueModal>
              </>   
            ) : (
              <>
                <LiqueModal open={openStockVariant} onClose={handleCloseStockVariant}>
                  <form>
                    <Box paddingTop={2} paddingBottom={1} display="flex" justifyContent="space-between" alignItems="center"
                      sx={{ position: "sticky", top: "0px", background: "white", zIndex: "2" }}
                    >
                      <Typography sx={subHeaderStyleContrast}>Edit Stock</Typography>
                      <Button sx={roudedIconButtonStyle} onClick={handleCloseStockVariant}>
                        <CloseIcon />
                      </Button>
                    </Box>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Typography marginBottom={2}>Ukuran Barang - Stok *</Typography>

                        {stockVariants.map((item, index) => (
                          <Grid
                            container
                            spacing={2}
                            key={index}
                            alignItems="center"
                            justifyContent="end"
                            marginBottom={2}
                          >
                            {/* Dropdown Ukuran */}
                            <Grid item xs={4}>
                              <TextField
                                fullWidth
                                type="text"
                                value={item.size}
                                onChange={(e) => handleSizeChange(e, index)}
                                label="Ukuran"
                              />
                            </Grid>

                            {/* Input Quantity */}
                            <Grid item xs={4} sm={3}>
                              <TextField
                                fullWidth
                                type="number"
                                value={item.quantity}
                                onChange={(e) => handleQuantityChange(e, index)}
                                label="Jumlah"
                              />
                            </Grid>
                            
                            {/* Input Order */}
                            <Grid item xs={4} sm={3}>
                              <TextField
                                fullWidth
                                type="number"
                                value={item.showOrder}
                                onChange={(e) => handleOrderChange(e, index)}
                                label="Urutan"
                              />
                            </Grid>

                            {/* Tombol Hapus */}
                            <Grid item xs={4} sm={2}>
                              <Button 
                                sx={{ 
                                  ...btnStyleOutlined, borderRadius: "50px", width: "100%", color: "red", border: "1px solid red",
                                  "&:disabled" : {
                                    color: "red",
                                    opacity: "0.2"
                                  }
                                }}
                                endIcon={<TrashIcon color="red" />}
                                onClick={() => handleRemoveSize(index)}
                                disabled={stockVariants.length === 1} 
                              >
                                Delete
                              </Button>
                            </Grid>
                          </Grid>
                        ))}

                        {/* Tombol Tambah */}
                        <Button
                          sx={{ ...btnStyleContrast, borderRadius: "50px", width: "200px"}}
                          onClick={handleAddSize}
                          marginTop={1}
                          endIcon={<AddIcon />}
                        >
                          Tambah Ukuran
                        </Button>
                      </Grid>
                    </Grid>
                    <Box display="flex" justifyContent="end" gap="5px" paddingY={1}
                      style={{ position: "sticky", bottom: "0", background: "white" }}
                    >
                      <Button
                        sx={{ ...btnStyleContrast, borderRadius: "50px", width: "200px"}}
                        onClick={updateStockVariant}
                        marginTop={1}
                        disabled={loading}
                      >
                        { loading ? 'Mohon menunggu...' :  'Save' }
                      </Button>
                    </Box>
                  </form>
                </LiqueModal>
              </>
            )
            
            }

          </Grid>


          <LiqueModal open={openFilter} onClose={() => setOpenFilter(false)}>
            <Grid container spacing={3} sx={{ position: "relative" }}>
              <Grid item xs={12}>
                <Typography variant="h5">Filter</Typography>
              </Grid>
                {
                  hakAkses?.position !== "Mitra" && (
                    <>
                      <Grid item xs={6}>
                        <Typography>Mitra</Typography>
                        <Autocomplete
                          options={partners}
                          getOptionLabel={(option) => option.name}
                          value={filterPartner ? { ...filterPartner } : null}
                          isOptionEqualToValue={(option, value) => {
                            return option.id === value.id;
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                          onChange={(event, newValue) =>
                            setFilterPartner(newValue)
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Status</Typography>
                        <TextField
                          fullWidth
                          select
                          value={filterState}
                          onChange={(e) => setFilterState(e.target.value)}
                        >
                          {filterStateArr.map((type) => (
                            <MenuItem key={type.value} value={type.value}>
                              {type.title}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Tag Utama</Typography>
                        <Autocomplete
                          multiple
                          options={tagMainList}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.title}
                          value={[...inputTagMainFilter]}
                          isOptionEqualToValue={(option, value) => {
                            return option.id === value.id;
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                          onChange={(event, newValue) =>
                            setInputTagMainFilter(newValue)
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Tag Sekunder</Typography>
                        <Autocomplete
                          multiple
                          options={tagSecondaryList}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.title}
                          value={[...inputTagSecondaryFilter]}
                          isOptionEqualToValue={(option, value) => {
                            return option.id === value.id;
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                          onChange={(event, newValue) =>
                            setInputTagSecondaryFilter(newValue)
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Brand</Typography>
                        <Autocomplete
                          multiple
                          options={brandList}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.title}
                          value={[...inputBrandFilter]}
                          isOptionEqualToValue={(option, value) => {
                            return option.id === value.id;
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                          onChange={(event, newValue) =>
                            setInputBrandFilter(newValue)
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Stok</Typography>
                        <TextField
                          fullWidth
                          select
                          value={filterStock}
                          onChange={(e) => setFilterStock(e.target.value)}
                        >
                          {filterStockArr.map((stock) => (
                            <MenuItem key={stock.value} value={stock.value}>
                              {stock.title}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} display="flex" justifyContent="end">
                        <Button
                          onClick={resetFilter}
                          sx={{ ...btnStyleContrast, width: "200px", borderRadius: "100px" }}  
                        >
                          Reset Filter
                        </Button>
                      </Grid>
                    </>
                  )
                }
            </Grid>

          </LiqueModal>

          <LiqueModal open={openSorting} onClose={handleCloseSorting}>
            <Grid container rowSpacing={3} sx={{ position: "relative" }}>
              <Grid item xs={12}>
                <Typography variant="h5">Ubah Urutan</Typography>
              </Grid>
              <Grid item xs={12}>
                <DndProvider backend={HTML5Backend}>
                  <StockSortableList stockItems={sortedData} />
                </DndProvider>
              </Grid>
              <Grid item xs={12} sx={{ position: "sticky", bottom: "0" }}>
                <Button
                  variant="contained"
                  onClick={handleSubmitSorting}
                  fullWidth
                  style={{ backgroundColor: "black", color: "white" }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </LiqueModal>
        </RootContainer>
      </Container>
    </Box>
  );
}
